export default __webpack_public_path__ + "static/media/ic-arrow-down-purple.270dce44.svg";